(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-accessories"]) return;
  try {
    
      var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations-accessories&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          initCollectionEvents();
        }
      };
      request.send();
    };

    var initCollectionEvents = function() {
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
    }
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations-accessories") {
        loadProductRecommendationsIntoSection();
        //console.log('load product reco');
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-cart"]) return;
  try {
    
      var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations-cart&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          initCollectionEvents();
        }
      };
      request.send();
    };

    var initCollectionEvents = function() {
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
    }
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations-cart") {
        loadProductRecommendationsIntoSection();
        //console.log('load product reco');
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-kids"]) return;
  try {
    
      var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations-kids&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          initCollectionEvents();
        }
      };
      request.send();
    };

    var initCollectionEvents = function() {
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
    }
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations-kids") {
        loadProductRecommendationsIntoSection();
        //console.log('load product reco');
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-men"]) return;
  try {
    
      var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations-men&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          initCollectionEvents();
        }
      };
      request.send();
    };

    var initCollectionEvents = function() {
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
    }
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations-men") {
        loadProductRecommendationsIntoSection();
        //console.log('load product reco');
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-women"]) return;
  try {
    
      var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations-women&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          initCollectionEvents();
        }
      };
      request.send();
    };

    var initCollectionEvents = function() {
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
    }
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations-women") {
        loadProductRecommendationsIntoSection();
        console.log('load product reco');
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
      var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          initCollectionEvents();
        }
      };
      request.send();
    };

    var initCollectionEvents = function() {
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
    }
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
        //console.log('load product reco');
        $("[data-collection-id]").each((function() {
          return function(index, element) {
            return Rubino.views.push(new Rubino.Views.Collection({
              el: element
            }));
          };
        })(this));
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
